export default "<app-alert-message></app-alert-message>\r\n<app-spinner [modal]=\"true\"></app-spinner>"